module.exports = __webpack_public_path__ + "static/media/exclusive-photo-product.1bee5bb8.jpg";